import { createHeader, createBulletPoint, createSubHeader } from "./componentHelpers"

export const renderLeadershipSection = (leadershipExperiences) => {
  if (!leadershipExperiences || leadershipExperiences.length === 0) {
    return []
  }
  
  return [
    ...createHeader("LEADERSHIP EXPERIENCE"),
    ...leadershipExperiences
      .filter((experience) => experience)
      .flatMap((experience) => {
        const affiliation = experience.affiliation || "AFFILIATION"
        const title = experience.title || "TITLE"
        const startDate = experience.startDate || "STARTDATE"
        const endDate = experience.endDate || "Present"
        const location = experience.location || "LOCATION"
        const bulletPoints = experience.bulletPoints || []

        return [
          ...createSubHeader(
            title,
            affiliation,
            location,
            startDate,
            endDate
          ),
          ...bulletPoints.map(b => createBulletPoint(b)),
        ]
      }),
  ]
}
